// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import {router} from './router';
import store from './store';
import VueRouter from 'vue-router';
import '@/permission'; // 权限
import Vant from 'vant';
import 'vant/lib/index.css';
import addAccessLog from '@/plugins/addAccessLog';
import urlParamProcess from '@/plugins/urlParamProcess';

Vue.use(Vant);
Vue.config.productionTip = false
Vue.use(VueRouter);
// 挂载日志访问的全局方法
Vue.use(addAccessLog);
// 挂载url处理的全局方法
Vue.use(urlParamProcess);
Vue.config.ignoredElements = ['wx-open-launch-weapp']
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js